
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "modal-window"
})
export default class ModalWindowComponent extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: "" }) title!: string;
  @Prop({ default: "600px" }) width!: string;

  get dialogStyle(): Record<string, string> {
    return {
      width: this.width,
      maxWidth: "calc(100vw - 32px)"
    };
  }

  close() {
    this.$emit("close");
  }
}
